<!-- 常见问题 -->
<template>
  <div class="commonQuestionList">
    <h2 class="title" data-aos="fade-down">常见问题</h2>
    <div class="tabContent warp" data-aos="fade-down" data-aos-delay="100">
      <!-- <a-tabs v-model="activeKey" @change="changeTab">
        <a-tab-pane
          v-for="(item, index) in questionList"
          :key="index"
          :tab="item.title"
          :forceRender="true"
        >
          <a-collapse
            :bordered="false"
            expand-icon-position="right"
            v-model="collapseKeys"
          >
            <template #expandIcon="props">
              <a-icon type="plus" v-if="!props.isActive" />
              <a-icon type="minus" v-else />
            </template>
            <a-collapse-panel
              v-for="node in item.data"
              :key="node.q"
              :header="node.q"
            >
              <a-textarea
                autoSize
                readonly
                class="answer"
                v-model="node.a"
              ></a-textarea>
            </a-collapse-panel>
          </a-collapse>
        </a-tab-pane>
      </a-tabs> -->
      <a-collapse
        :bordered="false"
        expand-icon-position="right"
        v-model="collapseKeys"
      >
        <template #expandIcon="props">
          <a-icon type="up" v-if="!props.isActive" />
          <a-icon type="down" v-else />
        </template>
        <a-collapse-panel
          v-for="node in questionList"
          :key="node.q"
          :header="node.q"
        >
          <a-textarea
            autoSize
            readonly
            class="answer"
            v-model="node.a"
          ></a-textarea>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Object,
      default: [],
    },
  },
  data() {
    return {
      questionList: this.dataList,
      activeKey: 0,
      collapseKeys: [],
    };
  },
  mounted() {
    // this.changeTab(0);
    this.collapseKeys = [this.questionList[0].q];
  },
  methods: {
    changeTab(key) {
      this.activeKey = key;
      this.collapseKeys = this.questionList[key].data.map((item) => item.q);
    },
  },
};
</script>
<style lang="sass" scoped>
.commonQuestionList {
  margin-top: 40px;
  padding-top: 40px;
  padding-bottom: 60px;
  background: #fff;
  .ant-collapse-borderless {
    background-color: #fff;
    }
.title {
  font-family: PingFang SC, PingFang SC;
font-weight: 600;
font-size: 32px;
color: #111111;
margin-bottom: 60px;
text-align: center;
}
.tabContent {
  width: 1200px !important;
  margin: 0 auto;
  .answer:focus {
    border: none;
    box-shadow: none;
  }
  .answer {
    font-weight: 400;
font-size: 14px;
color: rgba(0,0,0,0.6);
width: 100%;
border: none;
resize: none;
outline: none;
padding-left: 26px;
// background-color: #F7FAFE;
  }
  .ant-collapse {
    // background-color: #F7FAFE;
    .ant-collapse-item {
      border-color: #EAF0FF;
    }
    ::v-deep.ant-collapse-content-box {
        padding-bottom: 8px;
        }
    ::v-deep.ant-collapse-content-box {
      padding-left: 0px;

    }
    .ant-collapse-item-active {
      ::v-deep.ant-collapse-header {
        color: #165DFF !important;
        padding-bottom: 8px;
        .anticon {
          color: #165DFF !important;
        }
      }

    }
    ::v-deep.ant-collapse-header {
      font-size: 18px;
color: #333333;
padding-left: 0px;
padding-bottom: 20px;
padding-top: 16px;
margin-top: 16px;
      .anticon {
        color:#7F7F7F;
      }
    }
    ::v-deep.ant-collapse-header::before {
        content: '';
        width: 10px;
height: 10px;
background: #165DFF;
border-radius: 50%;
display: inline-block;
margin-right: 16px;
        }
  }
}
}
</style>
